import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const getVal = require('lodash/get');

const SuppCardComponent = (props) => {
  const {
    memberInfo,
    fieldOptions,
    fieldId,
    cssProperties,
    setFormSubmissionPayload,
    formSubmissionPayload,
    fieldValidation,
    requiredCardData,
    tableheaders,
  } = props;
  const [suppOptions, setSuppOptions] = useState([]);
  const [currentSelectedOption, setCurrentSelectedOption] = useState({});
  const handleChange = (e, currentSelectedCard) => {
    const { value } = e.target;
    const previousCardsData = formSubmissionPayload[fieldId]
      ? formSubmissionPayload[fieldId]
      : [];
    if (value === 'Yes') {
      // required card data
      const currentCardData = {};
      Object.keys(requiredCardData).forEach((key) => {
        const val = getVal(currentSelectedCard, requiredCardData[key]);
        if (val) {
          currentCardData[key] = val;
        }
      });
      previousCardsData.push(currentCardData);
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        elemId: null,
        [fieldId]: previousCardsData,
      });
      // add this card under currentSelectedOption
      setCurrentSelectedOption({
        ...currentSelectedOption,
        [currentSelectedCard.accountToken]: 'Yes',
      });
    }
    if (value === 'No') {
      const filteredCards = previousCardsData.filter(
        (card) => card.accountToken !== currentSelectedCard.accountToken
      );
      if (filteredCards.length === 0) {
        delete formSubmissionPayload[fieldId];
        setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null });
      } else {
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          elemId: null,
          [fieldId]: filteredCards,
        });
      }

      // remove this card from currentSelectedOption
      setCurrentSelectedOption({
        ...currentSelectedOption,
        [currentSelectedCard.accountToken]: 'No',
      });
    }
  };

  useEffect(() => {
    if (
      memberInfo.supplementaryAccounts
      && memberInfo.supplementaryAccounts.length > 0
    ) {
      setSuppOptions(memberInfo.supplementaryAccounts);
    }
  }, [memberInfo]);

  useEffect(() => {
    if (
      suppOptions
      && suppOptions.length > 0
      && formSubmissionPayload
      && formSubmissionPayload[fieldId]
      && formSubmissionPayload[fieldId].length > 0
    ) {
      const selectedCards = {};
      const selectedAccountTokens = [];
      formSubmissionPayload[fieldId].forEach((card) => {
        selectedAccountTokens.push(card.accountToken);
      });
      suppOptions.forEach((card) => {
        if (selectedAccountTokens.includes(card.accountToken)) {
          selectedCards[card.accountToken] = 'Yes';
        } else {
          selectedCards[card.accountToken] = 'No';
        }
      });
      setCurrentSelectedOption(selectedCards);
    } else if (suppOptions && suppOptions.length > 0) {
      // set every currentSelectedOption to 'No'
      const selectedCards = {};
      suppOptions.forEach((card) => {
        selectedCards[card.accountToken] = 'No';
      });
      setCurrentSelectedOption(selectedCards);
    }
  }, [suppOptions, fieldId]);

  return (
    <div className="col-md-offset-1 col-md-9" id={fieldId}>
      <table>
        <thead>
          <tr>
            {
              tableheaders && tableheaders.length > 0 && tableheaders.map((header) => (
                <th key={header}>{header}</th>
              ))
}

          </tr>
        </thead>
        <tbody>
          {suppOptions
            && suppOptions.length > 0
            && suppOptions.map((i, index) => (
              <tr key={i.accountToken}>
                <td>{i.holder.profile.embossedName} 様</td>
                <td>{i.identifiers.displayAccountNumber}</td>
                <td>
                  <div className="radio-group" style={{ display: 'flex' }}>
                    {fieldOptions.map((option, optionIndex) => (
                      <span
                        className={
                          cssProperties.radioDivClass
                            ? cssProperties.radioDivClass
                            : 'radio pad-4-r'
                        }
                        key={i.accountToken}
                      >
                        <input
                          id={`radio-${index}-${optionIndex}`}
                          type="radio"
                          name={`radio-${index}`}
                          value={option.value}
                          onChange={(e) => handleChange(e, i)}
                          checked={
                            currentSelectedOption[`${i.accountToken}`]
                            === option.value
                          }
                        />
                        <label htmlFor={`radio-${index}-${optionIndex}`}>
                          {option.fieldLabel}
                        </label>
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {suppOptions.length === 0
        && fieldValidation
        && fieldValidation.noSuppCardsMessage && (
          <div id="alert-error" className="alert dls-color-warning pad-1-t">
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{fieldValidation.noSuppCardsMessage}</span>
          </div>
      )}
    </div>
  );
};

SuppCardComponent.propTypes = {
  memberInfo: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  fieldOptions: PropTypes.string,
  cssProperties: PropTypes.string,
  requiredCardData: PropTypes.string,
  tableheaders: PropTypes.string,
  fieldId: PropTypes.string,
  fieldValidation: PropTypes.string,
  setFormSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default SuppCardComponent;
